import {
  AsYouType,
  isValidPhoneNumber,
  parsePhoneNumberFromString,
  type CountryCode,
} from 'libphonenumber-js/min';

export function formatAsYouType(input: string, country: CountryCode): string {
  return new AsYouType(country).input(input);
}

export function isValidPhone(input: string, country: CountryCode): boolean {
  if (!input.trim()) return false;
  return isValidPhoneNumber(input, country);
}

export function toE164(input: string, country: CountryCode): string | null {
  const parsed = parsePhoneNumberFromString(input, country);
  return parsed?.isValid() ? parsed.number : null;
}
